import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";
import { useEffect, useState } from "react";
import {
  fetchallUsersByPractices,
  getUserPracticeById,
  sendPasswordResetEmail,
} from "../../api";
import { EditUser } from "./EditUser";
import { jwtDecode } from "jwt-decode";
import React from "react";

export function ViewUsers({ refresh, onUserUpdate = () => {}}) {
  const [allUsers, setAllUsers] = useState([]);
  const [practices, setPractices] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [modalShow, setModalShow] = useState(false);
  const [passwordResetModal, setPasswordResetModal] = useState(false);

  useEffect(() => {
    async function fetchUsersAndPractices() {
      const token = sessionStorage.getItem("user");
      if (token) {
        const decoded = jwtDecode(token);
        const allPrac = await getUserPracticeById(decoded._id);
        setPractices(allPrac);

        const practiceNumbers = allPrac.map(
          (practice) => practice.practiceNumber
        );
        const findAllUsers = await fetchallUsersByPractices(practiceNumbers);
        setAllUsers(findAllUsers);
      }
    }
    fetchUsersAndPractices();
  }, [refresh]);

  const handleEditClick = (userId) => {
    setSelectedUser(userId);
    setModalShow(true);
  };

  async function handleResetPassword(user) {
    setSelectedUser(user); // ✅ Store selected user details
    setPasswordResetModal(true); // ✅ Show modal immediately
  
    try {
      await sendPasswordResetEmail(user.email); // ✅ Send password reset email
      console.log(`✅ Password reset email sent to ${user.email}`);
    } catch (error) {
      console.error("⛔ Error sending password reset email:", error);
    }
  }
  

  return (
    <div className="bg-transparent">
      {allUsers
        .sort((a, b) => a.lastName.localeCompare(b.lastName))
        .reduce((rows, user, index) => {
          if (index % 2 === 0) rows.push([]);
          rows[rows.length - 1].push(user);
          return rows;
        }, [])
        .map((row, rowIndex) => (
          <Row className="gy-3 mb-1" key={rowIndex}>
            {" "}
            {/* ✅ Adds spacing between rows */}
            {row.map((user) => (
              <Col md={6} xs={12} key={user._id}>
                
                <Container className="border-radius-0 pt-2 bg-white shadow-sm pb-3 d-flex flex-column h-100">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="fw-bold text-primary">
                      {user.lastName}, {user.firstName}
                    </p>
                    <Button variant="" onClick={() => handleEditClick(user.id)}>
                      <i className="fas fa-edit text-primary"></i>
                    </Button>
                  </div>

                  <div className="flex-grow-1">
                    <div className="row">
                      <div className="col-4 text-end text-primary">Email:</div>
                      <div className="col-8">{user.email}</div>
                    </div>
                    <div className="row">
                      <div className="col-4 text-end text-primary">
                        Phone Number:
                      </div>
                      <div className="col-8">{user.phoneNumber}</div>
                    </div>
                    <div className="row">
                      <div className="col-4 text-end text-primary">
                        Occupation:
                      </div>
                      <div className="col-8">{user.occupation}</div>
                    </div>
                    <div className="row">
                      <div className="col-4 text-end text-primary">
                        HPCSA#:
                      </div>
                      <div className="col-8">{user.hpcsa}</div>
                    </div>

                    {/* Practices Section */}
                    <div className="row">
                      <div className="col-4 text-end text-primary">
                        Practice(s):
                      </div>
                      <div className="col-8">
                        {user.practice.map((practiceId, index) => (
                          <div key={index}>
                            {practices.find(
                              (p) => p.practiceNumber === practiceId
                            )?.practiceName || "Unknown Practice"}
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Roles Section */}
                    <div className="row mt-3 mb-3">
                      <div className="col-4 text-end text-primary">Roles:</div>
                      <div className="col-8">
                        {user.role.map((role, index) => (
                          <div key={index}>{role}</div>
                        ))}
                      </div>
                    </div>

                    {/* Password Icon */}
                    <div className="row align-items-center">
                      {/* Label Column */}
                      <div className="col-4 text-end text-primary">
                        Reset Password:
                      </div>

                      {/* Button Column */}
                      <div className="col-8 d-flex align-items-center">
                        <Button
                          variant="outline-primary"
                          size="sm"
                          className="d-flex align-items-center"
                          onClick={() => handleResetPassword(user)} // ✅ Pass selected user
                        >
                          <i className="fas fa-key me-2 text-primary"></i>
                          Reset
                        </Button>
                      </div>
                    </div>
                  </div>
                </Container>
              </Col>
            ))}
          </Row>
        ))}
      {modalShow && (
        <EditUser
          show={modalShow}
          onHide={() => setModalShow(false)}
          userId={selectedUser}
          onUserUpdate={onUserUpdate}
        />
      )}
      {passwordResetModal && (
        <PasswordResetModal
          show={passwordResetModal}
          onHide={() => setPasswordResetModal(false)}
          user={selectedUser} // ✅ Pass user details
        />
      )}
    </div>
  );
}

// ✅ Password Reset Modal Component
function PasswordResetModal({ show, onHide, user }) {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header>
        <Modal.Title>Password Reset</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          The password reset request for{" "}
          <strong>
            {user?.firstName} {user?.lastName}
          </strong>{" "}
          has been initiated.
        </p>
        <p>
          An email will be sent shortly with instructions to reset the password.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
